<template>
    <section class="odocs-spaced">
        <p>
            <o-button icon-left="trash" variant="primary">
                Trash <o-tag label="12" />
            </o-button>
            <o-button>
                Notifications <o-tag label="4" badge size="small" />
            </o-button>
        </p>
        <p>
            <o-button>
                Profile <o-tag badge rounded variant="danger" />
            </o-button>
            <o-button>
                Inbox
                <o-tag
                    label="99+"
                    badge
                    rounded
                    variant="danger"
                    size="small" />
            </o-button>
        </p>
    </section>
</template>
